<template>
    <div style="width: 100%;min-width: 600px; ">

        <div style="padding: 0px 10px 0px 10px ;" >
                <span class="tipTitle-collapse">
                    调拨信息 - {{inDevAllotOrder.allotBatNo}}
                </span>
            <el-table :data="[inDevAllotOrder]">
                <el-table-column label="类型" v-if="inDevAllotOrder.type===CST_OrderType.IN || inDevAllotOrder.type===CST_OrderType.OUT " width="80px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type===CST_OrderType.OUT" color="#FFFFFF">出库</el-tag>
                        <el-tag type="success" v-else color="#FFFFFF">入库</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="outAgentName" label="调出" />
                <el-table-column prop="inAgentName" label="调入" />
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">{{_enums.DevAllotStatusEnum.getNameById(scope.row.status)}}</template>
                </el-table-column>
                <el-table-column label="操作" v-if="inDevAllotOrder.type===CST_OrderType.IN && inDevAllotOrder.status===CST_OrderStat.SEND" width="200px" align="center">
                    <template slot-scope="scope">
                        <div v-if="nativePayCode">
                            等待付款
                        </div>
                        <div v-else>
                            <el-button type="warning" round  size="mini" @click="confirmOrder(scope.row.allotBatNo, CST_OrderStat.REFS, scope.row.orderPayFlag)" >拒收</el-button>
                            <el-button type="primary" round  size="mini" @click="confirmOrder(scope.row.allotBatNo, CST_OrderStat.RECV, scope.row.orderPayFlag)" >
                                {{scope.row.orderPayFlag===2 && scope.row.orderAmount!==0 ?'付款&签收':'签收'}}
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div style="padding: 10px 10px 20px 10px">
            <el-steps :active="stepActive" finish-status="success">
                <el-step title="出库"></el-step>
                <el-step title="途中"></el-step>
                <el-step title="确认"></el-step>
            </el-steps>
        </div>

        <div v-if="nativePayCode" style="text-align: center;">
            <!-- native支付二维码展示 -->
            <vue-qr :text="nativePayCode" :size="200"></vue-qr>
            <div>
                <span style="font-weight: bolder; color: green; font-size: 18px;">请用微信扫码付款</span><br/>
                <span style="font-weight: normal; color: green; font-size: 30px;">¥{{orderAmount}}</span>
            </div>
            <div style="margin-top: 10px;">
                <el-button type="success" round size="max" @click="CheckPayResult" >已完成付款</el-button>
            </div>
        </div>

        <div v-else style="margin-left: 10px;margin-right: 10px; ">
            <span class="tipTitle-collapse">设备清单</span>
            <div style="margin-top: 10px; height: 400px; overflow-y: scroll;">
                <el-table :data="devAllotDetails" v-loading="loading" size="mini" border stripe @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"
                       v-if="inDevAllotOrder.orderPayFlag!==4 && inDevAllotOrder.type===CST_OrderType.IN && inDevAllotOrder.status===CST_OrderStat.RECV" />
                    <el-table-column type="index" label="序号"  align="center"/>
                    <el-table-column prop="devModel" label="设备型号"  align="center" />
                    <el-table-column prop="devBindStat" label="绑定状态" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag effect="dark" :type="scope.row.devBindStat===2?'success':'info'">{{_enums.DevBindStatusEnum.getNameById(scope.row.devBindStat)}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="devStrStat" label="仓储状态" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag effect="plain" :type="scope.row.devStrStat===1?'default':'danger'">{{_enums.DevStorageStatusEnum.getNameById(scope.row.devStrStat)}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="terSn" label="SN"   align="center"/>
                    <el-table-column prop="devType" label="类别"  align="center" />
                </el-table>
            </div>
            <!-- 分页栏 -->
            <div class="yx-flex-h-between" style="margin: 15px 0;">
                <div v-if="inDevAllotOrder.orderPayFlag===4 && _p_env.VUE_APP_DEV_FREE_ALLOT==='0'">
                    <el-tag effect="dark" type="info"><i class="el-icon-message-solid"></i> 免单设备只能自用，不可外调</el-tag>
                </div>
                <el-button icon="el-icon-truck" v-else-if="inDevAllotOrder.type===CST_OrderType.IN && inDevAllotOrder.status===CST_OrderStat.RECV" :disabled="disableBtn" type="danger"  size="mini" @click="emitToParentAllot()" >批量调拨出库</el-button>
                <div style="width: 10px;" v-else />

                <el-pagination small
                               :current-page.sync="page"
                               @current-change="currentChangeFA"
                               @size-change="sizeChangeFA"
                               layout="slot, sizes, prev, pager, next, total"
                               :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import vueQr from "vue-qr"
    import {URL_AREAS} from "../../utils/cons";
    export default {
        name: "DevAllotDetailDiv",
        props:["inDevAllotOrder"],
        components: { vueQr },
        data() {
            return {
                stepActive:2,
                allotBatNo: null,
                tradeNo: null,
                CST_OrderType: { OUT:'0', IN:'1' },
                CST_OrderStat: { SEND:1, RECV:2, REFS:3 },
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                disableBtn: true,
                times: 0,
                multipleSelection: [],
                devAllotDetails:[],
                nativePayCode: null,
                orderAmount: null
            };
        },
        mounted() {
            this.initDevAllotDetails();
            if(this.inDevAllotOrder.status>this.CST_OrderStat.SEND) this.stepActive = 3;
        },
        methods: {
            sizeChangeFA(currentSize) {
                this.size = currentSize;
                this.initDevAllotDetails();
            },
            currentChangeFA(currentPage) {
                this.page = currentPage;
                this.initDevAllotDetails();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            emitToParentFinishPay() {
                console.log("emitToParentFinishPay")
                this.$emit("onDataLoadFinishPay", this.inDevAllotOrder.allotBatNo)
            },
            emitToParent() {
                this.$emit('update:outDrawerClose', false);
            },
            emitToParentAllot() {
                let snTexts = "";
                try {
                    this.multipleSelection.forEach( item => {
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("只能调拨未绑定设备！[" + item.terSn + "]-[" + this._enums.DevBindStatusEnum.getNameById(item.devBindStat)) + "]";
                        }
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("只能调拨在库设备！[" + item.terSn + "]-[" + this._enums.DevStorageStatusEnum.getNameById(item.devStrStat)) + "]";
                        }
                        if(item.inSaleId) {
                            throw ("设备已分配客户经理，请先回收 ! 序列号[" + item.terSn + "]");
                        }
                        snTexts = snTexts + item.terSn + "\n";
                    })
                }
                catch (e) {
                    this.$message.error(e);
                    return;
                }
                this.$emit("onDataLoadSnTexts", snTexts)
            },
            sleep (delay) {
                let start = (new Date()).getTime()
                while ((new Date()).getTime() - start < delay) {
                    continue
                }
            },
            async CheckPayResult () {
                // 轮询结果
                const resp1 = await this.getRequest("/dev/devAllotConfirmPayResult" + "?tradeNo=" + this.tradeNo)
                if (resp1) {
                    let result = resp1.obj
                    if (result.result===1) { // 订单已支付
                        console.log("订单已支付")
                        this.stepActive = 3; //步骤完成
                        this.inDevAllotOrder.status = 2; //状态签收
                        this.inDevAllotOrder.devAllotStat.id = 2;
                        this.inDevAllotOrder.devAllotStat.desc = "签收";
                        // this.nativePayCode = null
                        this.emitToParentFinishPay();
                    }
                }
            },
            async confirmOrder(allotBatNo, status, orderPayFlag) {
                this.allotBatNo = allotBatNo
                let optTxt = '';

                  {
                    if(status===this.CST_OrderStat.RECV) {
                        orderPayFlag===2?optTxt='付款':optTxt='签收'
                    }
                    else if(status===this.CST_OrderStat.REFS) optTxt='拒收';
                    else return;
                }

                this.$confirm('【' + optTxt + '】调拨单号：' + allotBatNo, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    this.tradeNo = null
                    const resp = await this.putRequest("/dev/devAllotConfirm" + "?allotBatNo=" + allotBatNo + "&status=" + status)
                    if (resp && resp.status===200) {
                        if (resp.obj && resp.obj.flag===2) { // 需付款
                            this.orderAmount = resp.obj.amount
                            let payOrderResp = resp.obj.payOrderResp
                            this.tradeNo = payOrderResp.tradeNo
                            let dataJson = JSON.parse(payOrderResp.str)
                            this.nativePayCode = dataJson.code_url
                        } else {
                            this.stepActive = 3; //步骤完成
                            this.inDevAllotOrder.status = status; //状态拒收或签收
                            this.inDevAllotOrder.devAllotStat.id = status;
                            this.inDevAllotOrder.devAllotStat.desc = optTxt;
                            this.emitToParent();
                        }
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            initDevAllotDetails() {
                this.loading = true;
                let url = '/dev/devAllotDetails?page=' + this.page + '&size=' + this.size;
                if (this.inDevAllotOrder.allotBatNo) {
                    url += '&allotBatNo=' + this.inDevAllotOrder.allotBatNo;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devAllotDetails = resp.data;
                        this.total = resp.total;
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
